<template>
  <ServiceScreenLayout :parts="parts">
    <template v-slot:sip_trunk>
      <div class="row">
        <div class="col-md-7">
          <PbxDetails
            ref="pbxDet"
            :pbx="saleDefinition.sale.pbx.pbxPackage"
            :pbxDescriptions="computedDescriptionsList"
            :description="saleDefinition.sale.pbx.description"
          />
        </div>
        <div class="col-md-5" style="padding-top: 25px">
          <div class="card card-default">
            <div class="card-header">
              <h4>Wanatel Cloud PBX Package Details</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-5">DIDs: </div>
                    <div class="col-md-7">
                      <strong>
                        {{saleDefinition.sale.didNumbers.length}}
                      </strong>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5">Extensions: </div>
                    <div class="col-md-7">
                      <strong>
                        {{saleDefinition.sale.pbx.extensions.length}}
                      </strong>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5">Max Extensions: </div>
                    <div class="col-md-7">
                      <strong>
                        {{saleDefinition.sale.pbx.pbxPackage.maxExtensions}}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr/>
      <VoipDetails 
        :sipTrunk="saleDefinition.sale.sipTrunk"
        @save-sale="saveSaleDefinition"
      />
    </template>
    <template v-slot:did>
      <MultipleDid 
        :didList="saleDefinition.sale.didNumbers"
        @update-dids="updateDids"
        @add-new-did="addNewDid"
        @delete-did="deleteDid"
        @save-sale="saveSaleDefinition"
      />
    </template>
    <template v-slot:extension>
      <VoipExtensions 
        :extensionList="saleDefinition.sale.pbx.extensions"
        :pbx="saleDefinition.sale.pbx.pbxPackage"
        @update-extensions="updateExtensions"
        @add-new-extension="addNewExtension"
        @add-extensions="addExtensionRange"
        @delete-extension="deleteExtension"
      />
    </template>
    <template v-slot:admin>
      <div class="row">
        <div class="col-md-7">
          <div class="card-header" >
            <h4>Admin Details</h4>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <label>Admin URL</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="saleDefinition.sale.pbx.adminUrl"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row row-spacing">
              <div class="col-md-6">
                <label>Admin Username</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="saleDefinition.sale.pbx.adminUsername"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <label>Admin Password</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="saleDefinition.sale.pbx.adminPassword"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row row-spacing">
              <div class="col-md-12 row-spacing">
                <div class="form-row justify-content-between" v-allowed:view="['STAFF']">
                  <div class="form-group col-auto">
                    <button type="button" @click="saveSaleDefinition" class="btn btn-success">Save</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ServiceScreenLayout>
</template>

<script>
import ServiceScreenLayout from "@/layouts/ServiceScreenLayout";
import SaleFunctions from "@/pages/Services/SaleFunctions";

import VoipDetails from "@/components/ObjParts/SingleConstructed/VoipDetails";
import PbxDetails from "@/components/ObjParts/SingleConstructed/PbxDetails";
import VoipExtensions from "@/components/ObjParts/MultipleCaptured/VoipExtensions";
import MultipleDid from "@/components/ObjParts/MultipleCaptured/MultipleDid";

export default {
  extends: SaleFunctions,
  components: {
    ServiceScreenLayout,
    VoipDetails,
    VoipExtensions,
    MultipleDid,
    PbxDetails,
  },
  data() {
    return {
      saleNumber: null,
      parts: [
        {
          name: "sip_trunk",
          icon: "fa fa-user-circle",
          displayName: "Service",
          permissions: ["*"],
        },
        {
          name: "did",
          icon: "fa fa-phone-square",
          displayName: "DID",
          permissions: ["*"],
        },
        {
          name: "extension",
          icon: "fa fa-plug",
          displayName: "Extensions",
          permissions: ["*"],
        },
        {
          name: "admin",
          icon: "fa fa-cogs",
          displayName: "Admin",
          permissions: ["*"],
        },
      ],
      saleDefinition: {
        sale: {
          sipTrunk: {},
          pbx: {
            pbxPackage: {},
            extensions: [],
          },
          didNumbers: {},
        },
        meta: {
          pbx: {
            children: {
              pbxPackage: {
                partMeta: {
                  options: []
                }
              },
              extensions: {
                objMeta: {
                  new: {}
                }
              }
            }
          }
        },
      },
      descriptionsList: [],
    };
  },
  async mounted() {
    this.saleNumber = this.$route.params.saleNumber;
    this.fetchSaleDefinition(this.saleNumber).then(
      (success) => {
        this.saleDefinition = success.data;
        
        for (let i = 0; i < this.saleDefinition.meta.pbx.children.pbxPackage.partMeta.options.length; i++) {
          this.descriptionsList.push(this.saleDefinition.meta.pbx.children.pbxPackage.partMeta.options[i].description);
        }
      },
      (error) => {
        console.error(error);
        this.showError("Error Fetching Sale Definition", error);
      }
    );
  },
  computed: {
    computedDescriptionsList() {
      this.descriptionsList = [];
      for (let i = 0; i < this.saleDefinition.meta.pbx.children.pbxPackage.partMeta.options.length; i++) {
        if (this.saleDefinition.meta.pbx.children.pbxPackage.partMeta.options[i].maxExtensions >= this.saleDefinition.sale.pbx.extensions.length) {
          this.descriptionsList.push(this.saleDefinition.meta.pbx.children.pbxPackage.partMeta.options[i].description);
        }
      }
      return this.descriptionsList;
    },
  },
  methods: {
    loadSaleDefinition() {
      this.fetchSaleDefinition(this.saleNumber).then(
        (success) => {
          this.saleDefinition = success.data;
        },
        (error) => {
          console.error(error);
          this.showError("Error Fetching Sale Definition", error);
        }
      );
      return Promise.resolve('Success');
    },
    saveSaleDefinition: function() {
      this.saleDefinition.sale.pbx.description = this.$refs.pbxDet.description;

      for (let i = 0; i < this.saleDefinition.meta.pbx.children.pbxPackage.partMeta.options.length; i++) {
        if (this.$refs.pbxDet.pbx.description == this.saleDefinition.meta.pbx.children.pbxPackage.partMeta.options[i].description) {
          this.saleDefinition.sale.pbx.pbxPackage = this.saleDefinition.meta.pbx.children.pbxPackage.partMeta.options[i];
        }
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$http
            .put(
              this.$config.aimsAPIv2 +
                "sales/definition/" +
                this.saleDefinition.sale.saleNumber +
                "/update",
              this.saleDefinition
            )
            .then(
              (response) => {
                this.showSuccess("Save Success");
                this.saleDefinition = response.data;
                this.loadSaleDefinition();
              },
              (error) => {
                console.error(error);
                this.showError("Error Saving Voice Service", error);
                this.loadSaleDefinition();
              }
            );
        }
      });
    },
    updateExtensions: function(data) {
      this.saleDefinition.sale.pbx.extensions = data;
      this.saveSaleDefinition();
    },
    addNewExtension: function(data) {
      var extensionObj = this.saleDefinition.meta.pbx.children.extensions.objMeta.new;
      extensionObj.number = data;
      extensionObj.wanatelCloudPbxNumber = this.saleDefinition.sale.pbx.wanatelCloudPbxNumber;
      this.saleDefinition.sale.pbx.extensions.push(extensionObj);
      this.saveSaleDefinition();
    },
    addExtensionRange: function(data) {
      return this.$swal({
                title: "New Extensions",
                text: "You are about to add " + data.length + " extensions",
                type: 'info',
                confirmButtonText: 'Ok',
                showCancelButton: true,
            }).then((result) => {
                if (result.dismiss) {
                    return false;
                }
                if (result.value) {
                  for (let i = 0; i < data.length; i++) {
                    var extensionObj = Object.assign({}, this.saleDefinition.meta.pbx.children.extensions.objMeta.new);
                    extensionObj.number = data[i];
                    extensionObj.wanatelCloudPbxNumber = this.saleDefinition.sale.pbx.wanatelCloudPbxNumber;
                    this.saleDefinition.sale.pbx.extensions.push(extensionObj);
                  }
                  this.saveSaleDefinition();
                }
              });
    },
    deleteExtension: function(data) {
      if (this.saleDefinition.sale.pbx.extensions.length > 1) {
        for (let i = 0; i < this.saleDefinition.sale.pbx.extensions.length; i++) {
          if (this.saleDefinition.sale.pbx.extensions[i] == data) {
            this.deleteObjPart(this.saleDefinition.sale.pbx.extensions[i])
              .then(
                (response) => {
                  this.showSuccess("Delete Success");
                  this.loadSaleDefinition()
                    .then((response) => {
                      this.saleDefinition.sale.pbx.extensions = this.saleDefinition.sale.pbx.extensions.filter(ext => (ext != data));
                    }, (error) => {
                      console.error(error);
                      this.showError("Error Deleting Extension", error);
                    });
                },
                (error) => {
                  console.error(error);
                  this.showError("Error Deleting Extension", error);
              });
          }
        }
      } else {
        return this.$swal({
          title: "Error",
          text: "You can't delete the last extension",
          type: 'warning',
          confirmButtonText: 'Ok',
        });
      }
    },
    updateDids: function(data) {
      this.saleDefinition.sale.didNumbers = data;
      this.saveSaleDefinition();
    },
    addNewDid: function(data) {
      var didObj = this.saleDefinition.meta.didNumbers.objMeta.new;
      didObj.number = data.number;
      didObj.ported = data.ported;
      this.saleDefinition.sale.didNumbers.push(didObj);
      this.saveSaleDefinition();
    },
    deleteDid: function(data) {
      if (this.saleDefinition.sale.didNumbers.length > 1) {
        for (let i = 0; i < this.saleDefinition.sale.didNumbers.length; i++) {
          if (this.saleDefinition.sale.didNumbers[i] == data) {
            this.deleteObjPart(this.saleDefinition.sale.didNumbers[i])
              .then(
                (response) => {
                  this.showSuccess("Delete Success");
                  this.loadSaleDefinition()
                    .then((response) => {
                      this.saleDefinition.sale.didNumbers = this.saleDefinition.sale.didNumbers.filter(ext => (ext != data));
                    }, (error) => {
                      console.error(error);
                      this.showError("Error Deleting DID Number", error);
                    });
                },
                (error) => {
                  console.error(error);
                  this.showError("Error Deleting DID Number", error);
              });
          }
        }
      } else {
        return this.$swal({
          title: "Error",
          text: "You can't delete the last DID Number",
          type: 'warning',
          confirmButtonText: 'Ok',
        });
      }
    },
  },
};
</script>